import { EmptyState } from 'components/empty.state';
import { GroupOutlined } from '@mui/icons-material';
import React from 'react';
import { format } from "date-fns";
import { fr } from 'date-fns/locale';
import { Avatar, Button, Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Link } from 'react-router-dom';
import { East } from '@mui/icons-material';

interface Props {
    applications: Array<any>;
}

const CandidatesPartial = ({applications}: Props) => {

    if (applications.length <= 0) return (<EmptyState icon={<GroupOutlined />} title='Aucun candidat' description="Personne n'a encore postulé à cette mission." />);

    return (
        <TableContainer sx={{p: '1rem 1.5rem'}} component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Nom</TableCell>
                        <TableCell align="left">Statut</TableCell>
                        <TableCell align="left">Date Candidature</TableCell>
                        <TableCell align="left">Téléphone</TableCell>
                        <TableCell align="right"></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {applications.map((application) => (
                        <TableRow key={application.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell component="th" scope="row" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                <Avatar src={application.user.avatar_url} sx={{ width: 32, height: 32, backgroundColor: 'divider', mr: '0.5rem' }}>{!application.user.avatarUrl && application.user.full_name[0].toUpperCase()}</Avatar>
                                {application.user.full_name}
                            </TableCell>
                            <TableCell align="left"><Chip label={application.user.synced ? 'Intérimaire' : 'Candidat'} color={application.user.synced ? 'success' : 'info'} component='span'/></TableCell>
                            <TableCell align="left">{format(Date.parse(application.created_at), 'dd/MM/yy', {locale: fr})}</TableCell>
                            <TableCell align="left">{application.user.phone_number}</TableCell>
                            <TableCell align="right"><Button variant='outlined' size='small' color='secondary' sx={{borderColor: '#DCDFE3', color: '#393E42', width: 32, height: 32, minWidth: 32, p: 0}} component={Link} to={`/dashboard/candidates/${application.user.id}`}><East sx={{fontSize: 12}} /></Button></TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export { CandidatesPartial };